import React from 'react';
import cx from 'classnames';

import { BodyCopy } from '@xingternal/typography';

import styles from './EntityInfo.css';

type EntityInfoDataType = {
    value?: JSX.Element | string,
    label?: JSX.Element | string,
    className?: string,
    testId?: string
  };
type EntityInfoProps = {
  data: EntityInfoDataType[],
  className?: string,
  condensed?: boolean
};

const renderInfoBlock = (block: EntityInfoDataType, key: number) => (
  <div
    key={key}
    className={cx(styles.entityInfoBlock, block?.className ? {
      [styles[block.className]]: block.className,
    } : undefined)}
  >
    <BodyCopy
      className={styles.infoBlockText}
      size={'small'}
      sizeWide={'medium'}
      data-testid={block.testId}
    >
      <span className={styles.entityInfoBlockValue}>{block.value}</span>
      <span className={styles.label}>{block.label}</span>
    </BodyCopy>
  </div>
);


const EntityInfo = ({ data, className, condensed }: EntityInfoProps) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <div
      className={cx(
        styles.entityInfoBlockWrapper,
        { [styles.condensed]: condensed },
        className
      )}
    >
      {data.map((item, key) => renderInfoBlock(item, key))}
    </div>
  );
};

export default EntityInfo;
